import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { defaults } from "chart.js";

defaults.font.family = "'Yekan', 'sans-serif'";
defaults.font.size = 16;
defaults.font.weight = 700;
defaults.color = "#292D32";
defaults.borderColor = "#fff";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  scales: {
    scaleOverride: true,

    y: {
      position: "right",
      border: {
        display: true
      },

      grid: {
        tickWidth: 0,
        color: "#F0F5F7",
        alignToPixels: true
      }
    },
    x: {
      border: {
        display: true
      },
      grid: {
        tickWidth: 0,
        color: "#F0F5F7",
        alignToPixels: true
      }
    }
  },
  plugins: {
    legend: {
      position: "top",
      align: "right",
      rtl: true,
      display: false,

      labels: {
        usePointStyle: true,
        pointStyle: "circle",

        // generateLabels: (chart) => {
        //   console.log(chart.legend);
        //   return [1, 2];
        // },
        font: {
          family: "'Yekan', 'sans-serif'",
          size: 14,
          weight: "normal"
        }
      }
    },
    tooltip: {
      bodyFont: {
        family: "'Yekan', 'sans-serif'", // Add your font here to change the font of your tooltip body
        size: 16
      },
      titleFont: {
        family: "'Yekan', 'sans-serif'",
        size: 16 // Add your font here to change the font of your tooltip title
      }
    }
  }
};

const labels = ["شهریور", "مرداد", "تیر", "خرداد", "اردبیهشت", "فروردین"];

export function ReserveFirstHalf({ StatisticInfo }) {
  const [accepteddata, setaccepteddata] = useState([0,0,0,0,0,0]);
  const [unaccepteddata, setunaccepteddata] = useState([0,0,0,0,0,0]);
  useEffect(() => {}, []);
  const getmonth = m => {
    const months = ["شهریور", "مرداد", "تیر", "خرداد", "اردبیهشت", "فروردین"];
    const arr = m.split("-");
    const mo = arr[1];
    let monthname;
    switch (mo) {
      case "01":
       return "فروردین";
        break;
      case "02":
       return "اردبیهشت";

        break;

      case "03":
       return "خرداد";
        break;

      case "04":
       return "تیر";
        break;

      case "05":
       return "مرداد";
        break;

      case "06":
       return "شهریور";
        break;

      default:
        break;
    }
    return monthname;
  };
 useEffect(() => {
    for (let x of StatisticInfo.success_monthly_reserves) {
        for (let y in labels) {
          if (labels[y]===getmonth(x.date)) {
            setaccepteddata(datas=>({
                ...datas,
                [y]: x.count
             }))
          }
        }
      }
 }, [])
 useEffect(() => {
    for (let x of StatisticInfo.failed_monthly_reserves) {
        
        for (let y in labels) {
            
          if (labels[y]===getmonth(x.date)) {
             
            setunaccepteddata(datas=>({
                ...datas,
                [y]: x.count
             }))
          }
        }
      }
 }, [])
  const data = {
    labels,

    datasets: [
      {
        label: "رد شده ",
        data: Object.values(accepteddata),
        backgroundColor: "#00A6A6",
        borderRadius: 12,
        width: 37,
        borderSkipped: false
      },
      {
        label: " تایید شده ",
        data: Object.values(unaccepteddata),
        backgroundColor: "#F48E2F",
        borderRadius: 12,

        width: 37,
        borderSkipped: false
      }
    ]
  };
  return (
    <div className="">
      <Bar
        datasetIdKey="label"
        options={options}
        data={data}
        style={{ fontFamily: "'Yekan', 'sans-serif'" }}
      />
    </div>
  );
}

export default ReserveFirstHalf;
